import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider } from './contexts/AuthContext';
import { useAuth } from './contexts/AuthContext';
import Navbar from './components/Navbar';
import LandingPage from './components/LandingPage';
import Login from './components/Login';
import VerifyEmail from './components/VerifyEmail';
import ResetPassword from './components/ResetPassword';
import ForgotPassword from './components/ForgotPassword';
import TeacherDashboard from './components/TeacherDashboard';
import StudentDashboard from './components/StudentDashboard';
import GuardianDashboard from './components/GuardianDashboard';
import CreateStudent from './components/CreateStudent';
import CreateHomework from './components/CreateHomework';
import EditHomework from './components/EditHomework';
import TeacherSettings from './components/TeacherSettings';
import StudentsList from './components/StudentsList';
import HomeworkList from './components/HomeworkList';
import SubmissionList from './components/SubmissionList';
import StudentProgress from './components/StudentProgress';
import StudentHomeworks from './components/StudentHomeworks';
import AdminDashboard from './components/AdminDashboard';
import Analytics from './components/Analytics';
import './App.css';

function ProtectedRoute({ children, allowedTypes }) {
  const { user, userType } = useAuth();
  
  if (!user) {
    return <Navigate to="/login" replace />;
  }
  
  if (allowedTypes && !allowedTypes.includes(userType)) {
    return <Navigate to="/dashboard" replace />;
  }
  
  return children;
}

function AppRoutes() {
  const { user, userType } = useAuth();
  
  return (
    <div className="min-h-screen bg-gray-50">
      {user && <Navbar />}
      <div className={user ? "pt-16" : ""}>
        <Routes>
          <Route path="/login" element={!user ? <Login /> : <Navigate to="/dashboard" replace />} />
          <Route path="/" element={!user ? <LandingPage /> : <Navigate to="/dashboard" replace />} />
          
          {/* Rotas de autenticação - públicas */}
          <Route path="/verify-email" element={<VerifyEmail />} />
          <Route path="/reset-password" element={<ResetPassword />} />
          <Route path="/forgot-password" element={<ForgotPassword />} />
          
          <Route path="/dashboard" element={
            <ProtectedRoute>
              {userType === 'teacher' && <TeacherDashboard />}
              {userType === 'student' && <StudentDashboard />}
              {userType === 'guardian' && <GuardianDashboard />}
              {userType === 'admin' && <AdminDashboard />}
            </ProtectedRoute>
          } />
          
          {/* Rotas do Professor */}
          <Route path="/create-student" element={
            <ProtectedRoute allowedTypes={['teacher']}>
              <CreateStudent />
            </ProtectedRoute>
          } />
          
          <Route path="/create-homework" element={
            <ProtectedRoute allowedTypes={['teacher']}>
              <CreateHomework />
            </ProtectedRoute>
          } />

          <Route path="/edit-homework/:homeworkId" element={
            <ProtectedRoute allowedTypes={['teacher']}>
              <EditHomework />
            </ProtectedRoute>
          } />

          <Route path="/settings" element={
            <ProtectedRoute allowedTypes={['teacher']}>
              <TeacherSettings />
            </ProtectedRoute>
          } />

          <Route path="/students" element={
            <ProtectedRoute allowedTypes={['teacher']}>
              <StudentsList />
            </ProtectedRoute>
          } />
          
          <Route path="/homeworks" element={
            <ProtectedRoute>
              <HomeworkList />
            </ProtectedRoute>
          } />
          
          <Route path="/homework/:homeworkId/submissions" element={
            <ProtectedRoute allowedTypes={['teacher']}>
              <SubmissionList />
            </ProtectedRoute>
          } />

          <Route path="/student/:id/progress" element={
            <ProtectedRoute allowedTypes={['teacher', 'guardian']}>
              <StudentProgress />
            </ProtectedRoute>
          } />

          <Route path="/student/:id/homeworks" element={
            <ProtectedRoute allowedTypes={['teacher', 'guardian']}>
              <StudentHomeworks />
            </ProtectedRoute>
          } />
          
          <Route path="/admin" element={
            <ProtectedRoute allowedTypes={['teacher']}>
              <AdminDashboard />
            </ProtectedRoute>
          } />
          
          <Route path="/analytics" element={
            <ProtectedRoute allowedTypes={['guardian']}>
              <Analytics />
            </ProtectedRoute>
          } />
        </Routes>
      </div>
    </div>
  );
}

function App() {
  return (
    <AuthProvider>
      <Router>
        <AppRoutes />
      </Router>
    </AuthProvider>
  );
}

export default App; 